import { FC } from 'react';

import { SearchType } from '../../../types';
import { getSearchTypeLabelText } from '../../utils/helpers';

import styles from './SearchTypeLabel.module.css';

type SearchTypeLabelProps = {
  variant?: 'label' | 'badge';
  searchType: SearchType;
};
const SearchTypeLabel: FC<SearchTypeLabelProps> = ({ variant = 'label', searchType }) => {
  const text = getSearchTypeLabelText(searchType);
  return (
    <>
      {text !== '*' && (
        <div className={variant === 'label' ? styles.searchTypeLabel : styles.searchTypeBadge}>
          <div>{text}</div>
        </div>
      )}
    </>
  );
};
export default SearchTypeLabel;
